import { useState, useEffect } from "react";
import StateHeader from "../components/MainHeader";
import Chart1 from "../components/MainDashboard/Chart1";
import StockPipelineChart from "../components/MainDashboard/StockPipelineChart";
import StockByFacilityChart from "../components/MainDashboard/StockByFacilityChart";
import FacilityDistributionChart from "../components/MainDashboard/FacilityDistributionChart";
import DDWHTop10Chart from "../components/MainDashboard/DDWHTop10Chart";
import DDWHPipelineChart from "../components/MainDashboard/DDWHPipelineChart";
import ProductCategoryChart from "../components/MainDashboard/ProductCategoryChart";
import Footer from "../components/Footer";
import { fetchDashboardSummary, fetchHmisStockStats } from "../data/api";

const SummaryCard3 = ({ title, value, subtitle, color = "blue" }) => (
  <div className={`summary-card ${color}`}>
    <h4 className="sc-title">{title}</h4>
    <span className="bg-circle" style={{ backgroundColor: color }}></span>
    <h2 className="sc-value">{value}</h2>
    <p className="sc-subtitle">{subtitle}</p>
  </div>
);

const MainDashboard = () => {
  const [summary, setSummary] = useState(null);
  const [stockStats, setStockStats] = useState(null);

  useEffect(() => {
    fetchDashboardSummary().then(r => setSummary(r.data)).catch(console.error);
    fetchHmisStockStats().then(r => setStockStats(r.data)).catch(console.error);
  }, []);

  const summaryData = summary && stockStats ? [
    {
      title: "Overall Stock Availability",
      value: `${stockStats.overall_availability}%`,
      color: "blue",
      subtitle: `${stockStats.total_stores} monitored stores`,
    },
    {
      title: "Facilities > 90%",
      value: `${stockStats.above_90} (${((stockStats.above_90 / stockStats.total_stores) * 100).toFixed(1)}%)`,
      color: "green",
      subtitle: `of ${stockStats.total_stores} stores`,
    },
    {
      title: "Total Districts",
      value: summary.totalDistricts,
      color: "orange",
      subtitle: `${summary.totalHmisFacilities} HMIS facilities`,
    },
    {
      title: "Total SKUs Tracked",
      value: `${summary.totalProducts}`,
      color: "red",
      subtitle: `${summary.totalCategories} categories`,
    },
    {
      title: "Total Stores",
      value: summary.totalStores?.toLocaleString(),
      color: "purple",
      subtitle: `${summary.totalStoreTypes} store types`,
    },
  ] : [];

  return (
    <>
      <StateHeader />
      <div className="main">
        <div className="summary-left">
          {summaryData.map((item, index) => (
            <SummaryCard3 key={index} {...item} />
          ))}
        </div>
      </div>
      <div className="main">
        <Chart1 />
        <div className="dashboard-grid">
          <StockPipelineChart />
          <StockByFacilityChart />
          <FacilityDistributionChart />
          <DDWHTop10Chart />
          <DDWHPipelineChart />
          <ProductCategoryChart />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MainDashboard;
